import { Injectable } from '@angular/core';
import { HttpClient } from './http-client.service';
import * as model from '../../models';
import { Logger } from '../logger.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { TicketCreationDTO } from "../../services/webservice"

@Injectable()
export class ShoppingCartApi {
	private shoppingCartUrl = '/api/shoppingcart/v1/shoppingCarts';
	private shoppingCartBaseUrl = '/api/shoppingcart/v1';

	constructor(private httpClient: HttpClient, private logger: Logger) {}

	public createShoppingCart(): Observable<model.ShoppingCart> {
		return this.httpClient.post(this.shoppingCartUrl)
			.map(response => response.json())
	}

	public getMyShoppingCart(): Observable<model.ShoppingCart> {
		return this.httpClient.get(this.shoppingCartUrl + "/myShoppingCart")
				.map(response => response.json())
	}

	public addTickets(url: string, ticketCreationDTOs: TicketCreationDTO[]): Observable<model.ShoppingCart> {
		let body = JSON.stringify(ticketCreationDTOs)
		this.logger.info("Add Tickets to ShoppingCart: " + ticketCreationDTOs);
		return this.httpClient.post(url, body)
			.map(response => <model.ShoppingCart>response.json())
	}

	public addVisualTickets(url: string, ticketCreationDTOs: TicketCreationDTO[]): Observable<model.ShoppingCart> {
		let body = JSON.stringify(ticketCreationDTOs)
		this.logger.info("Add Visual Tickets to ShoppingCart: " + ticketCreationDTOs);
		return this.httpClient.post(url, body)
			.map(response => <model.ShoppingCart>response.json())
	}

	public addVisualBulkTickets(url: string, ticketCreationDTOs: TicketCreationDTO[]): Observable<model.ShoppingCart> {
		let body = JSON.stringify(ticketCreationDTOs)
		this.logger.info("Add Visual Bulk Tickets to ShoppingCart: " + ticketCreationDTOs);
		return this.httpClient.post(url, body)
			.map(response => <model.ShoppingCart>response.json())
	}

	public getDisplayShoppingCart(url: string): Observable<model.DisplayShoppingCart> {
		return this.httpClient.get(url)
				.map(response => response.json())
	}

	public removeTicket(shoppingCartSecureId: string, ticketItemUuid: string): Observable<model.ShoppingCart> {
		return this.httpClient.delete(this.shoppingCartUrl + "/" + shoppingCartSecureId + "/ticket/" + ticketItemUuid)
			.map(response => <model.ShoppingCart>response.json())
	}

	public removeTickets(url: string, ticketItemUuids: string[]): Observable<model.ShoppingCart> {
		for (let i = 0; i < ticketItemUuids.length; i++) {
			if (i === 0) {
				url += "?ticketItemUuids=" + ticketItemUuids[i]
			} else {
				url += "&ticketItemUuids=" + ticketItemUuids[i]
			}
		}
		return this.httpClient.delete(url)
			.map(response => <model.ShoppingCart>response.json())
	}

	public deleteShoppingCart(url: string): Observable<Response> {
		return this.httpClient.delete(url)
	}

	public detachShoppingCart(url: string, description: string, expiration: string): Observable<Response> {
		let body = JSON.stringify({ description, expiration })
		return this.httpClient.post(url, body)
	}

	public attachShoppingCart(url: string): Observable<Response> {
		return this.httpClient.post(url)
	}
	public getDetachedShoppingCarts(): Observable<model.ShoppingCart[]>{
		return this.httpClient.get(this.shoppingCartBaseUrl + "/detached/shoppingCarts")
			.map(response => response.json()._embedded)
			.filter(e => e)
			.map(e => e.shoppingCarts);
	}
	public getAttachLink(shoppingCart: model.ShoppingCart) {
		return this.shoppingCartBaseUrl + "/shoppingCarts/" + shoppingCart.secureId + "/attach";
	}
	public getDeleteLink(shoppingCart: model.ShoppingCart) {
		return this.shoppingCartBaseUrl + "/shoppingCarts/" + shoppingCart.secureId;
	}
	public getDisplayLink(shoppingCart: model.ShoppingCart) {
		return this.shoppingCartBaseUrl + "/shoppingCarts/" + shoppingCart.secureId + "/display";
	}
	public getAvailableShipmentTypes(shoppingCartSecureId: string): Observable<model.AvailableShipmentTypeDTO> {
		return this.httpClient.get(this.shoppingCartUrl + "/" + shoppingCartSecureId + "/shipmentTypes")
			.map(response => response.json());
	}
}



// WEBPACK FOOTER //
// ./src/app/services/webservice/shoppingcart-api.service.ts